import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import noblogs from "../../public/error/noblogs.json";
import { useRouter } from "next/router";

export default function NoBlogs() {
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  useEffect;
  return (
    <div>
      <div className=" grid grid-cols-12 gap-4 md:gap-6  ">
        <div className="w-full  flex justify-center flex-col col-span-12">
          <Lottie animationData={noblogs} loop={true} className="h-[331px]" />
          <div className="w-full justify-center">
            {lang == "en" ? (
              <div>
                <p className="mt-6 text-[48px] font-[590] flex justify-center tracking-tight pb-2 text-gray-900 sm:text-4xl text-center">
                  No Blog Found
                </p>
                <hr className="bg-gradient-to-r mx-auto from-[#2EBBFF] via-[#FE17FF] to-[#6232EA] h-[5px] w-[7rem] rounded-[22px]" />

                <p className=" text-[18px] leading-[28px] pt-[36px] text-[#010140] text-center">
                  We are sorry, <br /> The blog you are looking for cannot be
                  found on the site, please check it
                </p>
              </div>
            ) : (
              <div>
                <p className="mt-6 text-[48px] font-[590] flex justify-center tracking-tight pb-2 text-gray-900 sm:text-4xl text-center">
                  لا يوجد مدونات مماثلة
                </p>
                <hr className="bg-gradient-to-r mx-auto from-[#2EBBFF] via-[#FE17FF] to-[#6232EA] h-[5px] w-[7rem] rounded-[22px]" />

                <p className=" text-[18px] leading-[28px] pt-[36px] text-[#010140] text-center">
                  نعتذر, <br /> المدونة التي تبحث عنها غير موجودة يرجى التحقق
                  منها
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
